import React from 'react';
import styles from './Loader.module.css';

const Loader = () => <span className={styles.loader} />

export default Loader;